import React, { useContext, useEffect, useState } from "react";
import { Logo } from "../../../assets/images";
import { RootState } from "../../../redux/store/store";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import OfferCard from "../../../componet/offer-card";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import { useSelector } from "react-redux";
import OfferStudentModal from "../../../componet/offer-student-modal";
import {
  createStudentOfferService,
  getAllStudentOfferService,
  sendOfferService,
} from "../../../services/student-offer";
import { getSpecialPromoCode } from "../../../services/promo-code-service";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import { SnackbarContext } from "../../../config/hooks/use-toast";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const OfferStudent = () => {
  const role = useSelector(
    (state: RootState) => state?.user?.userData?.role.name,
  );
  const userData = useSelector((state: RootState) => state?.user?.userData);

  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState<any>(null);
  const [selectedOffer, setSelectedOffer] = useState<any>(null);
  const [isConfirmModal, setIsConfirmModal] = useState(false);

  const [isPeriodModalOpen, setIsPeriodModalOpen] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState<
    "MONTHLY" | "TRIMESTER" | "SEMESTER" | "YEARLY"
  >("MONTHLY");
  const [paymentFile, setPaymentFile] = useState<File | null>(null);
  const [paymentMethod, setPaymentMethod] = useState<"online" | "upload">(
    "upload",
  );
  const [promoCode, setPromoCode] = useState("");
  const [specialPromoCode, setSpecialPromoCode] = useState<string | null>(null);
  const [isSpecialPromoActive, setIsSpecialPromoActive] = useState(false);

  const snackbarContext = useContext(SnackbarContext);

  const fetchData = () => {
    setLoading(true);
    getAllStudentOfferService()
      .then((res) => {
        setData(res.data);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleUpdateOffer = (updatedOffer: any) => {
    setData((prevOffers: any[]) =>
      prevOffers.map((offer) =>
        offer.id === updatedOffer.id ? updatedOffer : offer,
      ),
    );
  };

  const handleUpdateAfterDelete = () => {
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [role]);

  useEffect(() => {
    if (role === "ROLE_STUDENT" && userData?.id) {
      getSpecialPromoCode(userData.id)
        .then((data) => {
          const code = (data as any)?.code;
          if (code) {
            setSpecialPromoCode(code);
            if (!promoCode || promoCode === code) {
              setPromoCode(code);
              setIsSpecialPromoActive(true);
            }
          }
        })
        .catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role, userData?.id]);

  useEffect(() => {
    if (isSpecialPromoActive && selectedPeriod === "YEARLY") {
      setSelectedPeriod("MONTHLY");
    }
  }, [isSpecialPromoActive, selectedPeriod]);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleAction = (formData: any) => {
    createStudentOfferService(formData)
      .then(() => {
        fetchData();
        handleCloseModal();
        snackbarContext?.showMessage(
          "Succes",
          "Offre ajoutee avec succes",
          "success",
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleCloseProfileDialog = () => {
    setSelectedProfile(null);
  };

  const handleOfferClick = (offer: any) => {
    setSelectedOffer(offer);
    const isFreeOffer =
      offer.price === 0 ||
      (offer.monthlyPrice === 0 &&
        offer.trimesterPrice === 0 &&
        offer.semesterPrice === 0 &&
        offer.yearlyPrice === 0);

    if (isFreeOffer) {
      setIsConfirmModal(true);
    } else {
      setIsPeriodModalOpen(true);
      setSelectedPeriod("MONTHLY");
      setPaymentFile(null);
      setPaymentMethod("upload");
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setPaymentFile(e.target.files[0]);
    }
  };

  const handlePeriodConfirm = () => {
    if (isSpecialPromoActive && selectedPeriod === "YEARLY") {
      snackbarContext?.showMessage(
        "Erreur",
        "Le code promo special n'est pas valable pour l'offre annuelle",
        "error",
      );
      return;
    }

    if (paymentMethod === "upload" && !paymentFile) {
      snackbarContext?.showMessage(
        "Erreur",
        "Veuillez televerser un recu de paiement",
        "error",
      );
      return;
    }

    const formData = new FormData();
    formData.append("selectedPeriod", selectedPeriod);
    formData.append("paymentMethod", paymentMethod);
    if (promoCode) {
      formData.append("promoCode", promoCode);
    }
    if (paymentMethod === "upload" && paymentFile) {
      formData.append("paymentImage", paymentFile);
    }

    sendOfferService(selectedOffer.id, formData, "")
      .then(() => {
        setIsPeriodModalOpen(false);
        setPaymentFile(null);
        setSelectedOffer(null);
        setPaymentMethod("upload");
        snackbarContext?.showMessage(
          "Succes",
          "Votre demande a ete envoyee avec succes",
          "success",
        );
      })
      .catch((e) => {
        console.log(e);
        snackbarContext?.showMessage(
          "Erreur",
          "Une erreur est survenue lors de l'envoi de la demande",
          "error",
        );
      });
  };

  const handleClosePeriodModal = () => {
    setIsPeriodModalOpen(false);
    setPaymentFile(null);
    setSelectedOffer(null);
    setPaymentMethod("upload");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50/50 via-white to-teal-50/30">
      <div
        className={`flex flex-col items-center gap-8 w-full px-4 py-10 max-w-7xl mx-auto ${
          loading
            ? "justify-center items-center h-[60vh]"
            : data.length === 0
              ? "justify-center items-center h-[60vh]"
              : ""
        }`}
      >
        {/* Popup de selection de la periode */}
        <Dialog
          open={isPeriodModalOpen}
          onClose={handleClosePeriodModal}
          fullWidth
          maxWidth="xs"
          PaperProps={{
            style: { borderRadius: 16, overflow: "hidden" },
          }}
        >
          <DialogTitle className="flex items-center justify-between text-white bg-primary">
            <span className="text-xl font-montserrat_semi_bold">
              Selection de la periode
            </span>
            <IconButton onClick={handleClosePeriodModal} className="text-white">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className="px-4 py-6">
            <div
              className="mb-8"
              ref={(el) => {
                if (el && isPeriodModalOpen) {
                  setTimeout(
                    () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
                    100,
                  );
                }
              }}
            >
              <label
                htmlFor="promo-code-input"
                className="block mb-2 text-base font-bold text-primary"
              >
                Code Promo (optionnel)
              </label>
              <input
                id="promo-code-input"
                type="text"
                value={promoCode}
                onChange={(e) => {
                  const value = e.target.value;
                  setPromoCode(value);
                  const isSpecial =
                    value === specialPromoCode && Boolean(specialPromoCode);
                  setIsSpecialPromoActive(isSpecial);
                  if (isSpecial && selectedPeriod === "YEARLY") {
                    setSelectedPeriod("MONTHLY");
                  }
                }}
                placeholder="Entrez votre code promo ici"
                className="w-full px-4 py-3 text-lg font-semibold border-2 rounded-lg border-primary focus:outline-none focus:ring-2 focus:ring-primary bg-yellow-50"
                style={{ letterSpacing: "0.1em" }}
              />
              {isSpecialPromoActive && (
                <span className="block mt-3 text-xs font-semibold text-green-700">
                  Code special actif - periodes annuelles desactivees
                </span>
              )}
            </div>
            <div className="mb-6">
              <Typography variant="h6" className="mb-3 font-montserrat_medium">
                Choisissez la periode d'abonnement
              </Typography>
              <div className="flex justify-center gap-2 mb-4">
                {["MONTHLY", "TRIMESTER", "SEMESTER", "YEARLY"].map((period) => {
                  const periodDisabled =
                    isSpecialPromoActive && period === "YEARLY";
                  return (
                    <button
                      key={period}
                      className={`px-4 py-2 text-sm font-bold rounded-lg border transition-all duration-300 ${
                        selectedPeriod === period
                          ? "bg-primary text-white border-primary shadow"
                          : "bg-white text-primary border-primary hover:bg-blue-50"
                      } ${periodDisabled ? "opacity-60 cursor-not-allowed" : ""}`}
                      onClick={() =>
                        !periodDisabled && setSelectedPeriod(period as any)
                      }
                      disabled={periodDisabled}
                    >
                      {period === "MONTHLY" && "Mensuel"}
                      {period === "TRIMESTER" && "Trimestriel"}
                      {period === "SEMESTER" && "Semestriel"}
                      {period === "YEARLY" && "Annuel"}
                    </button>
                  );
                })}
              </div>
            </div>
            <div className="p-4 mb-6 rounded-lg bg-gray-50">
              <Typography variant="h6" className="mb-4 font-montserrat_semi_bold">
                Details du paiement
              </Typography>
              <div className="mb-6">
                <Typography className="mb-3 font-montserrat_medium">
                  Methode de paiement: Televerser un recu
                </Typography>
              </div>
              <div
                className="flex flex-col items-center justify-center w-full transition-colors border-2 border-gray-300 border-dashed rounded-lg cursor-pointer h-28 sm:h-32 bg-gray-50 hover:bg-gray-100"
                onClick={() =>
                  document.getElementById("payment-file-input")?.click()
                }
              >
                <div className="flex flex-col items-center justify-center px-4">
                  <CloudUploadIcon className="w-6 h-6 mb-2 text-gray-500 sm:w-8 sm:h-8" />
                  <p className="mb-1 text-xs text-center text-gray-500 sm:mb-2 sm:text-sm">
                    <span className="font-semibold">Cliquez pour televerser</span>
                  </p>
                  <p className="text-xs text-center text-gray-500">
                    JPG, PNG ou PDF (MAX. 5MB)
                  </p>
                </div>
                <input
                  type="file"
                  id="payment-file-input"
                  className="hidden"
                  onChange={handleFileChange}
                  accept="image/*,.pdf"
                />
              </div>
              {paymentFile && (
                <div className="p-2 mt-3 border border-green-200 rounded-lg bg-green-50">
                  <p className="text-xs font-medium text-green-700 truncate sm:text-sm">
                    Fichier selectionne: {paymentFile.name}
                  </p>
                </div>
              )}
            </div>
            <div className="flex flex-col justify-end space-y-3 sm:flex-row sm:space-y-0 sm:space-x-3">
              <Button
                variant="outlined"
                onClick={handleClosePeriodModal}
                className="order-2 w-full px-4 py-2 text-sm text-gray-700 border-gray-300 rounded-lg sm:w-auto sm:px-6 sm:py-2 sm:text-base font-montserrat_medium sm:order-1"
              >
                Annuler
              </Button>
              <Button
                variant="contained"
                onClick={handlePeriodConfirm}
                disabled={paymentMethod === "upload" && !paymentFile}
                className={`w-full sm:w-auto font-montserrat_semi_bold bg-primary text-white py-3 sm:py-2 px-4 sm:px-6 rounded-lg text-sm sm:text-base order-1 sm:order-2 ${
                  paymentMethod === "upload" && !paymentFile
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:bg-primary-dark"
                }`}
              >
                {paymentMethod === "online"
                  ? "Payer en ligne"
                  : "Confirmer et Envoyer"}
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Interface principale */}
        {loading ? (
          <div className="flex flex-col items-center justify-center w-full h-[40vh]">
            <div className="mb-6">
              <img
                src={Logo}
                alt="Logo"
                className="w-20 h-20 animate-spin"
                style={{ animationDuration: "1.2s" }}
              />
            </div>
            <h2 className="text-lg font-semibold text-primary">
              Chargement des offres...
            </h2>
          </div>
        ) : isConfirmModal && selectedOffer ? (
          <div className="w-full min-h-[40vh] flex flex-col items-center justify-center px-4">
            <div className="flex flex-col items-center w-full max-w-md p-6 bg-white shadow-xl sm:p-8 rounded-2xl">
              <div className="mb-6 text-center">
                <h2 className="mb-2 text-2xl font-bold text-primary">
                  {selectedOffer.title}
                </h2>
                <p className="text-lg text-gray-600">Offre gratuite</p>
              </div>
              <p className="mb-6 text-center text-gray-700">
                Vous allez rejoindre cette offre gratuitement !
              </p>
              <div className="flex flex-col w-full gap-3 sm:flex-row sm:gap-4">
                <Button
                  variant="outlined"
                  onClick={() => {
                    setIsConfirmModal(false);
                    setSelectedOffer(null);
                  }}
                  className="order-2 w-full px-6 py-3 text-gray-700 border-gray-300 rounded-lg sm:w-auto sm:order-1"
                >
                  Annuler
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    sendOfferService(selectedOffer.id, {}, "")
                      .then(() => {
                        fetchData();
                        setIsConfirmModal(false);
                        setSelectedOffer(null);
                        snackbarContext?.showMessage(
                          "Succes",
                          "Vous avez rejoint l'offre gratuite avec succes",
                          "success",
                        );
                        if (selectedOffer.groupId) {
                          window.location.href = `/dashboard/group/${selectedOffer.groupId}`;
                        }
                      })
                      .catch((e: any) => {
                        console.log(e);
                        snackbarContext?.showMessage(
                          "Erreur",
                          "Erreur lors de la souscription a l'offre gratuite",
                          "error",
                        );
                      });
                  }}
                  className="order-1 w-full px-6 py-3 font-bold text-white rounded-lg bg-primary sm:w-auto sm:order-2"
                >
                  Confirmer
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <>
            {data && data.length > 0 ? (
              <div className="flex flex-col items-center w-full">
                <div className="grid w-full grid-cols-1 gap-8 max-w-7xl lg:grid-cols-2 2xl:grid-cols-3 justify-items-center">
                  {data.map((offer: any, index: number) => (
                    <div key={index} className="flex justify-center w-full">
                      <OfferCard
                        offer={offer}
                        onclick={() => handleOfferClick(offer)}
                        onUpdateOffer={handleUpdateOffer}
                        onDeleteOffer={handleUpdateAfterDelete}
                      />
                    </div>
                  ))}

                  {role === "ROLE_ADMIN" && (
                    <div className="flex justify-center w-full">
                      <div
                        onClick={handleOpenModal}
                        className="flex flex-col items-center justify-center w-full max-w-[340px] h-[480px] transition-all duration-300 bg-white/50 backdrop-blur-sm border-2 border-emerald-200 border-dashed cursor-pointer group rounded-3xl hover:shadow-2xl hover:-translate-y-2 hover:border-emerald-400 hover:bg-white/80"
                      >
                        <div className="flex flex-col items-center text-gray-500 transition-colors duration-300 group-hover:text-emerald-600">
                          <div className="p-6 mb-4 transition-all duration-300 rounded-full bg-emerald-50 group-hover:bg-emerald-100 group-hover:scale-110">
                            <AddIcon style={{ fontSize: 48 }} />
                          </div>
                          <h3 className="mb-2 text-xl font-bold text-center">
                            Ajouter une Offre
                          </h3>
                          <p className="px-6 text-sm text-center text-gray-400 transition-colors duration-300 group-hover:text-emerald-500">
                            Cliquez ici pour creer une nouvelle offre
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center h-64 text-gray-500">
                <div className="mb-4 text-6xl">:(</div>
                <h3 className="mb-2 text-xl font-semibold">
                  Aucune offre disponible
                </h3>
                <p>Les nouvelles offres apparaitront ici bientot.</p>
                {role === "ROLE_ADMIN" && (
                  <div className="mt-8">
                    <div
                      onClick={handleOpenModal}
                      className="flex flex-col items-center justify-center h-48 transition-all duration-300 bg-white border-2 border-gray-300 border-dashed cursor-pointer group w-72 rounded-2xl hover:shadow-xl hover:-translate-y-1 hover:border-purple-400"
                    >
                      <div className="flex flex-col items-center text-gray-500 transition-colors duration-300 group-hover:text-purple-500">
                        <div className="p-4 mb-4 transition-colors duration-300 bg-gray-100 rounded-full group-hover:bg-purple-100">
                          <AddIcon style={{ fontSize: 36 }} />
                        </div>
                        <h3 className="mb-2 text-lg font-semibold text-center">
                          Ajouter une Offre
                        </h3>
                        <p className="px-4 text-sm text-center text-gray-400 transition-colors duration-300 group-hover:text-purple-400">
                          Creez votre premiere offre
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
        )}

        <OfferStudentModal
          open={isModalOpen}
          onClose={handleCloseModal}
          modalTitle="Ajouter Offre"
          buttonText="Ajouter"
          onButtonClick={handleAction}
        />

        <Dialog
          open={Boolean(selectedProfile)}
          onClose={handleCloseProfileDialog}
          maxWidth="md"
          fullWidth
          PaperProps={{
            className: "rounded-xl p-5",
            style: { maxWidth: "800px" },
          }}
        >
          <DialogTitle className="mb-3 text-2xl font-semibold text-center text-primary">
            Details du profil
          </DialogTitle>
          <DialogContent className="flex flex-col items-center">
            {selectedProfile && (
              <>
                <div className="flex items-center mb-4">
                  <PersonIcon className="mr-2 text-primary" />
                  <Typography variant="h6" className="text-xl font-medium">
                    {selectedProfile.fullName}
                  </Typography>
                </div>
                <div className="flex items-center mb-4">
                  <MailOutlineOutlinedIcon className="mr-2 text-primary" />
                  <Typography variant="body1" className="text-lg">
                    {selectedProfile.email}
                  </Typography>
                </div>
                <div className="flex items-center mb-4">
                  <PhoneIcon className="mr-2 text-primary" />
                  <Typography variant="body1" className="text-lg">
                    {selectedProfile.phoneNumber}
                  </Typography>
                </div>
              </>
            )}
          </DialogContent>
          <DialogActions className="justify-center">
            <Button
              onClick={handleCloseProfileDialog}
              className="px-6 py-2 text-white rounded-full bg-primary"
            >
              Fermer
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default OfferStudent;

